<template>
  <div class="banner-container">
    <banner-img></banner-img>
  </div>
</template>

<script>
import BannerImg from "./BannerImg";
export default {
  name: "Index",
  components: {
    BannerImg
  }
};
</script>

<style lang="scss" scoped>
.banner-container {
}
</style>
